import { Chip, Tooltip, Typography } from '@mui/material';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';
import { useDashboardTFunction } from '@retail/dashboard/i18n';
import { PercentChange } from './period';

const formatRatio = (ratio: number) => {
  const pct = Math.round(ratio * 100);
  const sign = pct > 0 ? '+' : '';
  return `${sign}${pct} %`;
};

interface Props {
  change: PercentChange;
  /** Whether an increase is a good thing (drives the delta chip colour). Defaults to true. */
  higherIsBetter?: boolean;
}

export const StatDelta = ({ change, higherIsBetter = true }: Props) => {
  const t = useDashboardTFunction();

  if (change.ratio === null) {
    return (
      <Tooltip title={t('dashboard.period.noPrevious')}>
        <Typography variant="caption" color="text.secondary">
          —
        </Typography>
      </Tooltip>
    );
  }
  if (change.direction === 'flat') {
    return <Chip size="small" variant="outlined" label={formatRatio(change.ratio)} />;
  }
  const isGood = change.direction === 'up' ? higherIsBetter : !higherIsBetter;
  return (
    <Chip
      size="small"
      color={isGood ? 'success' : 'error'}
      variant="outlined"
      icon={
        change.direction === 'up' ? (
          <ArrowUpwardRoundedIcon fontSize="small" />
        ) : (
          <ArrowDownwardRoundedIcon fontSize="small" />
        )
      }
      label={formatRatio(change.ratio)}
    />
  );
};
